export default [
  {
    title: "Introduction",
    body: "Welcome to HobbsTech Enterprises. These Terms and Conditions govern your use of our website www.hobbstech.co.zw and our services. By accessing our site and services, you agree to these Terms and Conditions in full.",
  },
  {
    title: "Service Use",
    body: "We provide technology solutions, including but not limited to payment gateway services. Users must not misuse our services in any manner.",
  },
  {
    title: "Intellectual Property",
    body: "All content on our website is the property of HobbsTech Enterprises and is protected by copyright and intellectual property laws.",
  },
  {
    title: "Payments",
    body: "We operate on a payment-in-arrears model to ensure satisfaction before payment. Details of specific payment terms are outlined in our agreements with clients.",
  },
  {
    title: "Termination",
    body: "We reserve the right to terminate or suspend access to our services for any user who violates these Terms and Conditions.",
  },
  {
    title: "Governing Law   ",
    body: "These Terms are governed by the laws of Zimbabwe, with consideration given to compliance with international laws as necessary.",
  },
  {
    title: "Amendment",
    body: "We may update these Terms from time to time. Continued use of the service will be deemed acceptance of the updated terms.",
  },
];
